module.exports = __webpack_public_path__ + "img/sand-dune-decal-05.c7e29acb.png";